import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormsModule} from '@angular/forms';
import {environment} from '../../environments/environment';
import {InputText} from 'primeng/inputtext';
import {Button} from 'primeng/button';
import {AppDialogService} from '../services/AppDialogService';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    FormsModule,
    InputText,
    Button
  ],
})
export class LoginComponent {

  email = '';
  passw = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialogs: AppDialogService
  ) {
    const data = this.route.snapshot.data;
    if (data.hasOwnProperty('logout')) {
      localStorage.removeItem('apiToken');
      this.router.navigateByUrl('/login').then(() => {})
    }
  }

  login() {

    const api = environment.api;

    fetch(
      api + '/api/user/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: this.email,
          password: this.passw
        })
      })
      .then(r => r.json())
      .then(r => {
        if(r.hasOwnProperty('token') && r.token !== '') {
          localStorage.setItem('apiToken', r.token);
          this.router.navigateByUrl('/forms/builder/index').then(()=>{});
        }
      })
      .catch(() => {
        this.dialogs.Alert("Error","Login failed")
      })
  }
}
